module.exports = __webpack_public_path__ + "static/img/logo_white.d6fedfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hotel/logo_white.png
// module id = aggH
// module chunks = 1